<template>
  <label
    class="pl-input"
    :class="[$slots.suffix ? 'pl-input_suffix': false, $slots.prefix ? 'pl-input_prefix' : false]"
  >
    <slot name="suffix"></slot>
    <input class="pl-input_inner" :type="type" :placeholder="placeholder" v-model="inputValue" />
    <slot name="prefix"></slot>
  </label>
</template>

<script>
export default {
  name: 'PlInput',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: '請輸入'
    },
    value: {
      default: ''
    }
  },
  watch: {
    value (val) {
      this.inputValue = val
    },
    inputValue (val) {
      this.$emit('input', val)
    }
  },
  data () {
    return {
      inputValue: this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.pl-input {
  height: 45px;
  display: block;
  text-align: left;
  border-radius: 5px;
  position: relative;
  padding: 10px 15px;
  box-sizing: border-box;
  border: 1px solid #c2c2c2;
  &_inner {
    margin: 0;
    padding: 0;
    border: none;
    height: 100%;
    outline: none;
    font-size: 13px;
    vertical-align: top;
    &::placeholder,
    &::-webkit-input-placeholder {
      color: #9c9c9c;
    }
  }
}
</style>
